<template>
<div id="Home" class="routes_components">
  <div class="home_showcase">
    <div class="row home_row1">
      <router-link to="/tictactoe" tag="button" id="ttt_hit" class="col card_button"><span class="card_button_text">Tic tac toe</span></router-link>
      <router-link to="/dotsandboxes" tag="button" id="db_hit" class="col card_button"><span class="card_button_text">Dots and boxes</span></router-link>
    </div>
    <div class="row home_row2">
      <router-link to="/findthenumber" tag="button" id="fn_hit" class="col card_button"><span class="card_button_text">Find the number</span></router-link>
      <router-link to="/trueorfalse" tag="button" id="tf_hit" class="col card_button"><span class="card_button_text">True or false</span></router-link>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style>

</style>
